export default __webpack_public_path__ + "static/media/map-icon.16c6b593.png";